<template>
<div class="hotel-content">
    <!-- 酒店政策、订房须知 -->
    <div class="hotel-block" v-if="hotel.hotel_policies.length > 0">
        <div class="detail-normal-title">{{ $t('poi.hotelPolicy') }}</div>
        <div class="terms-wrapper">
            <div class="term" v-for="(item, index) in hotel.hotel_policies" :key="`policy-${index}`">
                <div class="term-title">{{ item.name }}</div>
                <div class="term-detail">{{ item.description }}</div>
            </div>
        </div>
    </div>
    <!-- 酒店设施 -->
    <div class="hotel-block" v-if="hotel.hotel_facilities.length > 0">
        <div class="detail-normal-title">{{ $t('poi.hotelFacility') }}</div>
        <div class="facilities-list">
            <div class="facility" v-for="(item, index) in hotel.hotel_facilities" :key="`facility-${index}`">
                <div class="facility-icon">
                    <img :src="`/image/hotel/${item.image_name}.${ item.image_name == 'aircraft' || item.image_name == 'fitness' || item.image_name == 'libin' || item.image_name == 'lift' || item.image_name == 'monitor' ? 'png' : 'svg'}`" />
                </div>
                <div class="facility-name">{{ item.name }}</div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    props: {
        hotel: {
            type: Object,
            default: () => {
                return {}
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.hotel-block {
    border-bottom: 8px solid #f0f0f0;
    padding: 20px 12px 16px;
}

.detail-normal-title {
    font-size: 16px;
    padding-left: 12px;
    position: relative;
    margin-bottom: 7px;
    color: #222215;
    font-weight: bold;
    font-family: "Montserrat";
}

.detail-normal-title:before {
    content: '';
    width: 3px;
    height: 17px;
    background-color: #f8a909;
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
}

.facilities-list {
    display: flex;
    flex-wrap: wrap;
}

.facilities-list .facility {
    width: 20%;
    text-align: center;
    font-size: 12px;
    margin-top: 15px;
}

.facility .facility-icon {
    width: 30px;
    height: 30px;
    margin: 0 auto 5px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.facility-name {
    font-size: 12px;
    color: #888888;
    margin-top: 6px;
}

.facility-icon image {
    width: 100%;
    height: 100%;
}

.hotel-block .terms-wrapper {
    margin-top: 23px;
}

.hotel-block .term {
    margin-top: 10px;
}

.hotel-block .term-title {
    font-size: 14px;
    color: #222125;
}

.hotel-block .term-detail {
    font-size: 12px;
    color: #888888;
    margin-top: 3px;
}

.hotel-block .term-detail text {
    margin-left: 15px;
}
</style>